"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AK_LIST = void 0;
exports.loadBaiduMap = loadBaiduMap;
var AK_LIST = exports.AK_LIST = ['Uh1hwpGbQ2y9PSEeQLSHTDik4TMJQzgn', 'HbgkTtx7gAPHeS9AGVw7QLkDdHWKgn9C'];

// 302: 配额超限  301: AK 不存在或非法  200: 正常
var QUOTA_EXCEEDED_STATUS = 302;
var loadPromise = null;
var currentAkIndex = 0;
function loadBaiduMap() {
  if (window.BMap && window._baiduMapAkVerified) {
    return Promise.resolve(window.BMap);
  }
  if (loadPromise) {
    return loadPromise;
  }
  loadPromise = tryLoadWithAk(currentAkIndex);
  return loadPromise;
}
function tryLoadWithAk(index) {
  if (index >= AK_LIST.length) {
    loadPromise = null;
    return Promise.reject(new Error('所有百度地图 AK 均已超限或无效，请检查配额'));
  }
  var ak = AK_LIST[index];
  return loadScript(ak).then(function () {
    return waitForBMap();
  }).then(function (BMap) {
    return verifyAk(ak, BMap, index);
  }).catch(function (err) {
    // 脚本加载或初始化失败，不重试
    loadPromise = null;
    return Promise.reject(err);
  });
}
function verifyAk(ak, BMap, index) {
  return new Promise(function (resolve, reject) {
    // 用天安门坐标做一次轻量探测
    var geocoder = new BMap.Geocoder();
    var point = new BMap.Point(116.404, 39.915);
    geocoder.getLocation(point, function (result) {
      var status = result ? 200 : QUOTA_EXCEEDED_STATUS;
      if (status === QUOTA_EXCEEDED_STATUS || !result) {
        console.warn("[baiduMap] AK[".concat(index, "] \u914D\u989D\u8D85\u9650\uFF0C\u5C1D\u8BD5\u4E0B\u4E00\u4E2A"));
        currentAkIndex = index + 1;
        // 需要重新加载脚本，先清除已有 BMap
        window.BMap = null;
        window._baiduMapAkVerified = false;
        loadPromise = null;
        loadPromise = loadScript(AK_LIST[currentAkIndex]).then(function () {
          return waitForBMap();
        }).then(function (nextBMap) {
          return verifyAk(AK_LIST[currentAkIndex], nextBMap, currentAkIndex);
        }).catch(reject);
        loadPromise.then(resolve).catch(reject);
        return;
      }
      window._baiduMapAkVerified = true;
      resolve(BMap);
    });
  });
}
function loadScript(ak) {
  // 如果已有同 AK 的脚本就跳过
  var existing = document.querySelector("script[data-baidu-ak=\"".concat(ak, "\"]"));
  if (existing) return Promise.resolve();
  return new Promise(function (resolve, reject) {
    window.BMAP_PROTOCOL = 'https';
    window.BMap_loadScriptTime = new Date().getTime();
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.setAttribute('data-baidu-ak', ak);
    script.src = "https://api.map.baidu.com/getscript?v=3.0&ak=".concat(ak, "&services=&t=").concat(window.BMap_loadScriptTime);
    var timeout = setTimeout(function () {
      reject(new Error('百度地图加载超时，请检查网络或 AK 白名单配置'));
    }, 15000);
    script.onload = function () {
      clearTimeout(timeout);
      resolve();
    };
    script.onerror = function () {
      clearTimeout(timeout);
      reject(new Error("\u767E\u5EA6\u5730\u56FE\u811A\u672C\u52A0\u8F7D\u5931\u8D25\uFF08AK: ".concat(ak, "\uFF09\uFF0C\u8BF7\u68C0\u67E5 AK \u662F\u5426\u6B63\u786E")));
    };
    document.head.appendChild(script);
  });
}
function waitForBMap() {
  var maxRetry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
  var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  return new Promise(function (resolve, reject) {
    var retry = 0;
    var timer = setInterval(function () {
      if (window.BMap) {
        clearInterval(timer);
        resolve(window.BMap);
        return;
      }
      retry += 1;
      if (retry >= maxRetry) {
        clearInterval(timer);
        reject(new Error('百度地图初始化失败，请确认 AK 已开启 JavaScript API 且域名在白名单中'));
      }
    }, interval);
  });
}